import { Badge } from "./Badge"

export interface BadgeCategoryArgs {
  id: number
  name: string
  badges: Badge[]
  type: "S" | "I"
}

export class BadgeCategory {
  id: number
  name: string
  type: "S" | "I"
  badges: Badge[]

  constructor(args: BadgeCategoryArgs) {
    this.id = args.id
    this.type = args.type
    this.name = args.name
    this.badges = args.badges
  }
}
